import { useFormatter } from '@api/useFormatter'
import { Col, InputNumber } from 'antd'
import React, { useMemo } from 'react'

import { useDestinationsContext } from '../../../../../Contexts/DestinationsContext'
import { useOrderContainersContext } from '../../../../../Contexts/OrderContainersContext'
import { useWizardMaster } from '../../../../../Contexts/WizardMasterContext'
import { isTruckLoaded } from '../../../../../util'
import { MultiTargetSwitcher } from './MultiTargetSwitcher'

export function PocketTarget({
  showGallonTag,
  showMultiTarget,
  targetIndex,
  canEdit,
  container,
  changeTargetLocation,
  index,
}) {
  const { formatVolume } = useFormatter()
  const formattedUnit = formatVolume(null, true)?.toUpperCase()

  return (
    <Col flex={1} className='vertical-flex'>
      {showMultiTarget && (
        <MultiTargetSwitcher
          container={container}
          targetIndex={targetIndex}
          changeTargetLocation={changeTargetLocation}
          index={index}
        />
      )}

      <div className='flex-div'>
        <PocketVolumeInput container={container} index={index} targetIndex={targetIndex} canEdit={canEdit} />
        {showGallonTag && <div className='uom-tag items-center'>{formattedUnit}</div>}
      </div>
    </Col>
  )
}
function PocketVolumeInput({ container, index, targetIndex, canEdit }) {
  const { changeVolume, volumes, maxVolumes } = useOrderContainersContext()
  const { getImpactedTankVolumes } = useDestinationsContext()
  const { setIsShortLoad, wizardOrder } = useWizardMaster()
  const truckIsLoaded = wizardOrder ? isTruckLoaded(wizardOrder.trip_status) : false
  const pocketMax = useMemo(() => {
    const truckIsLoaded = wizardOrder ? isTruckLoaded(wizardOrder.trip_status) : false
    if (truckIsLoaded) {
      return wizardOrder.compartments[index]?.targets?.map((t) => t.volume).reduce((a, b) => a + b)
    }
    const configMax = maxVolumes?.[index]
    const configDefault = volumes[index]
    return configMax || configDefault
  }, [wizardOrder, maxVolumes, volumes])

  return (
    <InputNumber
      size='small'
      value={container.targets[targetIndex].volume}
      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      parser={(value) => parseInt(value.replace(/\D/g, ''), 10)}
      max={pocketMax}
      inputMode='numeric'
      style={{ color: 'var(--gray-700)' }}
      min={0}
      step={1} // Ensure only whole numbers are selected
      onChange={(value) =>
        changeVolume(value, index, targetIndex, setIsShortLoad, getImpactedTankVolumes, truckIsLoaded, wizardOrder)
      }
      disabled={!canEdit}
    />
  )
}
